export default __webpack_public_path__ + "fonts/poppins-latin-600-normal.25ea813988479bcb587a.woff";